<template>
	<div class="compliance-content">
		<p class="compliance-title">{{ currentCompliance.display_name}} <span v-if="currentCompliance.route_name === 'welcome'">{{user.first_name}}!</span></p>
		<!-- <ProfileImage v-if="currentCompliance.id === 2"/>
    <br/> -->
		<div v-html="currentCompliance.body" @click="handleClick"></div>
		<div class="status-update" v-if="currentCompliance.id === 1 || currentCompliance.id === 69 || currentCompliance.id === 75 || currentCompliance.id === 49">
			<span :class="[currentVendorCompliance.vendor_compliance_status_id !== 1 ? 'active-btn' : 'disabled-btn']" @click="updateStatus(currentVendorCompliance.vendor_compliance_status_id, currentVendorCompliance.id)">I have read & understand</span>
		</div>
		<div class="status-update" v-if="currentCompliance.id === 58">
			<span :class="[currentVendorCompliance.vendor_compliance_status_id !== 1 ? 'active-btn' : 'disabled-btn']" @click="updateStatus(currentVendorCompliance.vendor_compliance_status_id, currentVendorCompliance.id)">I have read & understand</span>
		</div>
		<div class="status-update" v-if="currentCompliance.id === 60">
			<span :class="[currentVendorCompliance.vendor_compliance_status_id !== 1 ? 'active-btn' : 'disabled-btn']" @click="updateStatus(currentVendorCompliance.vendor_compliance_status_id, currentVendorCompliance.id)">I have read & understand</span>
		</div>
		<ComplianceFiles/>
		<br/>
		<UploadVendorComplianceFiles v-if="currentCompliance.allow_upload"/>
		<br/>
		<RequestSignature v-if="currentCompliance.template_id && currentVendorCompliance.vendor_compliance_status_id !== 1" :itemName="currentCompliance.display_name" :is-loading="loader" :complianceId="currentCompliance.id"/>
		<br/>
		<VendorComplianceDetails/>
		<br/>
		<br/>
	</div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import Cookies from "js-cookie";
import ComplianceFiles from "./ComplianceFiles.vue";
import UploadVendorComplianceFiles from "./UploadVendorComplianceDetails.vue";
import VendorComplianceDetails from "./VendorComplianceDetails.vue";
import ProfileImage from "./ProfileImage.vue";
import RequestSignature from "./RequestSignature";

export default {
	components: {
		ComplianceFiles,
		UploadVendorComplianceFiles,
		VendorComplianceDetails,
		ProfileImage,
		RequestSignature
	},
	data() {
		return {
			currentNav: {}
		};
	},
	watch: {
		$route(to, from) {
			this.getCompliance(to.query.id);
		}
	},
	computed: {
		...mapState("user", {
			user: state => state.user
		}),
		...mapState("compliance", {
			currentCompliance: state => state.currentCompliance,
			currentVendorCompliance: state => state.currentVendorCompliance,
		}),
		...mapGetters("compliance", {
			currentVendorCompliance: "getCurrentVendorCompliance"
		}),
		...mapState("signature", {
			loader: state => state.loader,
		}),
	},
	methods: {
		getCompliance(id) {
			var checkID = id;
			if (!checkID) {
				checkID = "1";
			}
			Cookies.set("ROUTE_ID", checkID);
			VueStore.dispatch("compliance/getCompliance", checkID);

			//var navItems = JSON.parse(JSON.stringify(this.nav));

			// if(Object.keys(navItems).length !== 0){
			//   let newNavItems = navItems.filter(
			//     eachObj => {
			//       const items = eachObj.items.filter(
			//         it => {
			//           return it.id === checkID
			//         })
			//       //console.log("items", items);
			//       if(items.length === 0){
			//         return false;
			//       }
			//       eachObj.items = items;
			//       return true;
			//   })
			//   var saveNavItems = newNavItems[0].items[0]
			//   this.currentNav = saveNavItems;
			//   sessionStorage.setItem("CURRENT-COMPLIANCE", JSON.stringify(saveNavItems));
			// }
		},
		handleClick(e) {
			if (e.target.matches(".doc-hub")) {
				VueStore.dispatch("notify/setVariable", {
					key: "viewDocHubInstructionModal",
					value: true
				});
			}
		},

		updateStatus(currentStatus, id) {
			if (currentStatus !== 1) {
				VueStore.dispatch("compliance/updateSelectedData", {
					key: "vendor_compliance_status_id",
					value: 1
				});
				VueStore.dispatch("compliance/update", id);
			}
		}
	},
	mounted() {
		// Prefer the id in the route over the cookie, so a stale cookie from a
		// previous session (e.g. after logout/login) can't override the URL.
		var id = this.$route.query.id || Cookies.get("ROUTE_ID");
		this.getCompliance(id);
	}
};
</script>
<style>
p {
	margin-top: 1em !important;
	margin-bottom: 1em !important;
}

.compliance-content ul {
	margin-left: 2em !important;
	margin-bottom: 1em !important;
	list-style: circle !important;
}

/* Keep numbered list markers inside the content area; without this, the
   inline styles stored in the DB body can push the numbers past the
   container's left padding. */
.compliance-content ol {
	margin-left: 0 !important;
	padding-left: 2em !important;
	list-style-position: outside;
}

.compliance-content {
	margin: 30px;
}
.compliance-title {
	font-size: 20px;
	font-weight: bold;
	margin-bottom: 20px;
}

.compliance-items {
	margin-top: 20px;
}

.bold {
	font-weight: bold;
}

.missing-title {
	font-size: 16px;
	font-weight: bold;
	margin-top: 20px;
}

.table td,
.table th {
	padding: 10px 10px 10px 0;
}

ol li {
	margin-bottom: 10px;
}

.doc-hub {
	cursor: pointer;
	font-weight: bold;
	color: #3273dc;
}

.doc-hub:hover {
	color: #363636;
}

.status-update {
	margin-top: 2em !important;
	margin-bottom: 1em !important;
}

.active-btn {
	-webkit-border-radius: 5;
	-moz-border-radius: 5;
	border-radius: 5px;
	color: #ffffff;
	background: #3273dc;
	padding: 10px;
	text-decoration: none;
}

.active-btn:hover {
	background: #3cb0fd;
	background-image: -webkit-linear-gradient(top, #3cb0fd, #3498db);
	background-image: -moz-linear-gradient(top, #3cb0fd, #3498db);
	background-image: -ms-linear-gradient(top, #3cb0fd, #3498db);
	background-image: -o-linear-gradient(top, #3cb0fd, #3498db);
	background-image: linear-gradient(to bottom, #3cb0fd, #3498db);
	text-decoration: none;
	cursor: pointer;
}

.disabled-btn {
	-webkit-border-radius: 5;
	-moz-border-radius: 5;
	border-radius: 5px;
	background: #cccccc;
	padding: 10px;
	text-decoration: none;
}

.disabled-btn:hover {
	text-decoration: none;
	cursor: not-allowed;
}
</style>
